import { Factory } from './Factory'
import Menu from '../EditorComponents/Counter/Menu'

export class CounterFactory extends Factory {
	constructor(qty = 1) {
		super()
		this.qty = qty
	}

	object() {
		return {
			id: this.id('counter'),
			containerId: this.id('container-id'),
			counterId: this.id('counter-id'),
			titleId: this.id('title-id'),
			slug: 'editor-counter',
			"assets": {
				"phone": [],
				"tablet": [],
				"desktop": []
			},
			"background": {
				"phone": "color",
				"tablet": "color",
				"desktop": "color"
			},
			"customClasses": [],
			"constantClasses": {
				"phone": [],
				"tablet": [],
				"desktop": []
			},
			"containerClasses": {
				"phone": [],
				"tablet": [],
				"desktop": []
			},
			"name": "Counter",
		}
	}

	properties() {
		return {
      content: [
        { key: 'counter-value', component: 'ContentText', text: 'Counter', property: 'counter'},
        { key: 'has-prefix', component: 'ContentToggle', text: 'has Prefix', property: 'hasPrefix'},
        { key: 'counter-prefix', component: 'ContentText', text: 'Prefix', property: 'prefix'},
        { key: 'has-suffix', component: 'ContentToggle', text:'has Suffix', property: 'hasSuffix'},
        { key: 'counter-suffix', component: 'ContentText', text: 'Suffix', property: 'suffix'},
        { key: 'has-title', component: 'ContentToggle', text: 'has a Title', property: 'hasTitle'},
        { key: 'counter-title', component: 'ContentText', text: 'Title', property: 'text'},
        { key: 'speed-animation', component: 'ContentText', text: 'Speed', property: 'interval'},
      ],
      containerStyles: [
        { key: 'border', component: 'BorderProperty', class: 'containerClasses', styles: 'containerStyles'},
        { key: 'background-color', component: 'BackgroundProperty', only: ['color'], styles: 'containerStyles'},
        { key: 'margin', component: 'MarginProperty', class: 'containerClasses'},
        { key: 'padding', component: 'PaddingProperty', class: 'containerClasses'},
        { key: 'rounded', component: 'RoundedProperty', class: 'containerClasses'},
        { key: 'shadow', component: 'ShadowProperty', class: 'containerClasses'},
        { key: 'text-alignment', component: 'TextAlignmentProperty', class: 'containerClasses'},
      ],
      counterStyles: [
        { key: 'font-color', component: 'TextColorProperty', styles: 'counterStyles'},
        { key: 'font-size', component: 'FontSizeProperty', styles: 'counterClasses'},
        { key: 'font-weight', component: 'FontWeightProperty', class: 'counterClasses'},
      ],
      titleStyles: [
        { key: 'font-color', component: 'TextColorProperty', styles: 'titleStyles'},
        { key: 'font-size', component: 'FontSizeProperty', class: 'titleClasses'},
        { key: 'font-weight', component: 'FontWeightProperty', class: 'titleClasses'},
      ],
			advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
		}
	}
}
